"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ImmutableDataController_1 = __importDefault(require("orbiter-core/src/datastructures/ImmutableDataController"));
const moment_1 = __importDefault(require("moment"));
const TimeSlot_1 = __importDefault(require("./model/TimeSlot"));
const basic_1 = require("orbiter-core/src/basic");
const exceptions_1 = require("orbiter-core/src/exceptions");
/**
 * Immutable class denoting time slot.
 */
class TimeSlotIDC extends ImmutableDataController_1.default {
    constructor(id, start, end, bookings, maxBookings) {
        super();
        // Force validation
        if (id !== null && !basic_1.isValidId(id)) {
            throw exceptions_1.ID_EXCEPTION;
        }
        if (moment_1.default(start) > moment_1.default(end)) {
            throw exceptions_1.INVALID_DATE_EXCEPTION;
        }
        if (!basic_1.isValidPositiveInteger(bookings) || !basic_1.isValidPositiveInteger(maxBookings) || bookings > maxBookings) {
            throw exceptions_1.VALUE_EXCEPTION;
        }
        this.id = id;
        this.start = start;
        this.end = end;
        this.bookings = bookings;
        this.maxBookings = maxBookings;
    }
    cloneHelper(_) {
        return new TimeSlotIDC(_.id === undefined ? this.id : _.id, _.start === undefined ? this.start : _.start, _.end === undefined ? this.end : _.end, _.bookings === undefined ? this.bookings : _.bookings, _.maxBookings === undefined ? this.maxBookings : _.maxBookings);
    }
    getId() {
        return this.id;
    }
    getStart() {
        return this.start;
    }
    getEnd() {
        return this.end;
    }
    getBookings() {
        return this.bookings;
    }
    getMaxBookings() {
        return this.maxBookings;
    }
    isAvailable() {
        return this.bookings < this.maxBookings;
    }
    toTimeSlot() {
        return new TimeSlot_1.default(moment_1.default(this.start), moment_1.default(this.end));
    }
}
__decorate([
    ImmutableDataController_1.default.dataProperty()
], TimeSlotIDC.prototype, "start", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty()
], TimeSlotIDC.prototype, "end", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty()
], TimeSlotIDC.prototype, "maxBookings", void 0);
__decorate([
    ImmutableDataController_1.default.dataProperty()
], TimeSlotIDC.prototype, "bookings", void 0);
exports.default = TimeSlotIDC;
//# sourceMappingURL=TimeSlotIDC.js.map